import { ArrowBack } from '@material-ui/icons';
import { StyledAvatar } from 'components/avatars';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import {
  FlexContainer,
  NewStyledIconContainer,
  StyledBox,
  StyledGrid,
  StyledTypography,
  VerticalFlexContainer,
} from 'styles/common';

import theme from 'constants/theme';

import { showErrorSnackbar } from 'services/snackbar';
import { saveOneOnOneRating } from 'services/task';

import StarRating from 'uiToolkit/StarRating';

// extract to some common code place and use everywhere
export const BorderAvatar = styled(StyledAvatar)`
  ${({ showBorder, theme }) =>
    showBorder &&
    css`
      border: 3px solid ${theme.palette.green.main};
      background-color: ${theme.palette.green.main};
    `}
  box-sizing: border-box;
`;

const Wrapper = styled(VerticalFlexContainer)`
  flex-grow: 1;
  background: white;
  padding: 1rem;
`;

const CursorStyledTypography = styled(StyledTypography)`
  cursor: pointer;
`;

function SubmissionRating({
  onViewInstanceDetails,
  onBackButtonClick,
  otherEmployee,
  instanceId,
  isManager: isHigherManager,
}) {
  const dispatch = useDispatch();
  const avatar = otherEmployee?.getProfileImage();

  const saveRating = (rating) => {
    saveOneOnOneRating({ rating, checkInId: instanceId }).catch(() => {
      dispatch(showErrorSnackbar('Sorry an error occurred while saving the rating'));
    });
  };

  return (
    <Wrapper>
      <VerticalFlexContainer alignitems="stretch">
        <StyledGrid container alignItems="center" onClick={onBackButtonClick} style={{ cursor: 'pointer' }}>
          <NewStyledIconContainer size="header" style={{ display: 'inline-flex' }}>
            <ArrowBack />
          </NewStyledIconContainer>
          <StyledTypography variant="body1" weight={600} leftGutter={1} color="textPrimary">
            Back
          </StyledTypography>
        </StyledGrid>

        <VerticalFlexContainer alignitems="center" topGutter={6} style={{ height: 'auto' }}>
          <BorderAvatar showBorder={!isHigherManager} size="big" src={avatar} />

          <StyledTypography topGutter={6} variant="h6" weight={600} customColor={theme.palette.text.heading}>
            {/* {isHigherManager
              ? 'Your current assessment of the team member basis this'
              : 'Your level of satisfaction with this'} */}
            Your level of satisfaction with this
          </StyledTypography>
          <StyledTypography
            bottomGutter={6}
            topGutter={2}
            variant="h6"
            weight={600}
            color="textSecondary"
            customColor={theme.palette.text.label}
          >
            1:1 with {otherEmployee.fullName}
          </StyledTypography>

          <StarRating onChange={saveRating} />
        </VerticalFlexContainer>
        <FlexContainer>
          <StyledBox
            flexgrow={1}
            bgcolor={theme.palette.background.grey}
            bottomGutter={4}
            leftGutter={2}
            rightGutter={2}
            flexcontainer
            flexdirection="column"
            alignitems="center"
            style={{ width: '95%' }}
          >
            <StyledTypography bottomGutter={1} topGutter={3} variant="body2" customColor={theme.palette.text.heading}>
              Thank you, 1:1 conversation is submitted successfully
            </StyledTypography>

            <CursorStyledTypography
              variant="body2"
              weight={600}
              color="primary"
              bottomGutter={3}
              onClick={onViewInstanceDetails}
            >
              View Submission
            </CursorStyledTypography>
          </StyledBox>
        </FlexContainer>
      </VerticalFlexContainer>
    </Wrapper>
  );
}

export default SubmissionRating;
